module.exports = __webpack_public_path__ + "98363a3bd7176e88450f74ec861c529c.png";